import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row,Drawer,Descriptions,Badge,Statistic} from 'antd';
import moment from 'moment';

// ...existing code

const OrderDetail = (props) => {
	const { onCancel, visible, item } = props;
	const product_list = item.product_list || item.goods_info_list;

	let width = window.innerWidth < 768 ? window.innerWidth * 0.8 : window.innerWidth * 0.35;

	return (
		<Drawer
			title={item.order_no ? <span>采购合同号: {item.order_no}</span> : <span>无合同订单</span>}
			placement="right"
			closable={false}
			onClose={onCancel}
			visible={visible}
			width={width}
		>
			<Descriptions title="商品信息" layout="vertical" bordered>
				{product_list.map((product, index) => (
					<Descriptions.Item key={index} label={`商品 ${index + 1}`}>
						<p>商品名称: {product.goodsName}</p>
						<p>一级分类: {product.levelOneName}</p>
						<p>二级分类: {product.levelTwoName}</p>
						<p>三级分类: {product.levelThreeName}</p>
						<p>材质: {product.goodsAttributeList.find((attr) => attr.attributeName === '材质')?.attributeValue}</p>
						<p>规格: {product.goodsAttributeList.find((attr) => attr.attributeName === '规格')?.attributeValue}</p>
						<p>产地: {product.goodsAttributeList.find((attr) => attr.attributeName === '产地')?.attributeValue}</p>
						<p>数量: {product.goodsMeasurementOne} {product.goodsMeasurementOneUnit}</p>
					</Descriptions.Item>
				))}
			</Descriptions>
		</Drawer>
	);
};

// ...export statement


export default OrderDetail;
